import { Image } from 'expo-image';
import React, { RefObject } from 'react';
import { Document, Page } from 'react-pdf';

export type CanvasImageRef = {
  setPdfScale: (scale: number) => void;
};

type Props = {
  base64: string | null;
  url: string | null;
  width: number;
  height: number;
  page: number;
  type: 'image' | 'pdf' | 'pdfpage' | 'svg' | 'svgpdf' | 'pdfimage';
  pdfScale?: number;
  ref?: RefObject<CanvasImageRef>;
};

export const CanvasImage = ({
  base64,
  url,
  page,
  width,
  height,
  type,
  pdfScale = 1,
  ref,
}: React.PropsWithChildren<Props>) => {
  const [internalPdfScale, setPdfScale] = React.useState(pdfScale);

  React.useImperativeHandle(
    ref,
    () => ({
      setPdfScale,
    }),
    [setPdfScale],
  );

  if (!base64 && !url) {
    return null;
  }

  if (type === 'pdf' || type === 'pdfpage') {
    if (base64 || url) {
      return (
        <Document file={base64 || url || undefined}>
          <Page
            pageNumber={page}
            width={width}
            height={height}
            devicePixelRatio={internalPdfScale}
            renderMode="canvas"
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        </Document>
      );
    }
    // PDF not supported
    return null;
  }

  return (
    <Image
      source={{ uri: base64 || url || undefined }}
      style={{
        width,
        height,
      }}
    />
  );
};
